import {TweenMax, Power2} from 'gsap';
import {Responsive} from "../../helper/responsive/responsive";

export class BlogMenu {

  public static element: HTMLElement;
  public static $element: JQuery<HTMLElement>;

  public static $blogHeader: JQuery<HTMLElement>;
  public static $aside: JQuery<HTMLElement>;

  public static init() {

    BlogMenu.$blogHeader = $('.Blog-header, .Header');
    BlogMenu.$aside = $('.Aside-menu');
    BlogMenu.events();
  }


  public static events() {

    BlogMenu.$blogHeader.find('.burger-menu').on('click', function () {
      if (BlogMenu.$aside.hasClass('open')) {
        BlogMenu.closeAsideMenu();
      } else {
        BlogMenu.openAsideMenu();
      }
    });

    BlogMenu.$aside.find('.cross').on('click', function () {
      if (BlogMenu.$aside.hasClass('open')) {
        BlogMenu.closeAsideMenu();
      }
    });

    Responsive.onWindowResize(function () {
      if (!Responsive.isMax('maxTablette')) {
        BlogMenu.closeAsideMenu();
      }
    });

    $(window).on('orientationchange', function(){
      BlogMenu.closeAsideMenu();
    });

    BlogMenu.$blogHeader.find('select').on('click', function () {
      console.log('change');
    });

    BlogMenu.$blogHeader.find('.desktop .SFake-dropdown').on('click', function () {
      setTimeout(function () {
        $("#theme-select option").each(function (index) {
          if ($(this).attr("selected")) {
            let url = $(this).val().toString();
            window.location.href = url;
          }
        });
      }, 10);
    });

    BlogMenu.$blogHeader.find('.mobile-only .SFake-dropdown').on('click', function () {
      setTimeout(function () {
        $("#theme-select-mobile option").each(function (index) {
          if ($(this).attr("selected")) {
            let url = $(this).val().toString();
            window.location.href = url;
          }
        });
      }, 10);
    });


    // recherche
    let $search = $('.Search');
    $search.data('opened', false);
    BlogMenu.$blogHeader.find('.search-btn, .search-button').on('click', function (e: Event) {
      e.preventDefault();

      if ($search.data('opened')) {
        TweenMax.to($search, 0.5, {height: 0, paddingTop: 0, paddingBottom: 0, autoAlpha: 0});
        $search.data('opened', false);
      }
      else {
        TweenMax.set($search, {height: 'auto', paddingTop: 20, paddingBottom: 20, autoAlpha: 1});
        TweenMax.from($search, 0.5, {height: 0, paddingTop: 0, paddingBottom: 0, autoAlpha: 0});
        $search.data('opened', true);
      }
      return false;
    });
  }


  public static openAsideMenu() {
    TweenMax.to(BlogMenu.$aside, 0.5, {
      x: '0%',
      ease: Power2.easeOut
    });
    BlogMenu.$aside.addClass('open');
    BlogMenu.$blogHeader.find('.burger-menu').addClass('open');
  }


  public static closeAsideMenu() {
    TweenMax.to(BlogMenu.$aside, 0.5, {
      x: '-100%',
      ease: Power2.easeOut
    });
    BlogMenu.$aside.removeClass('open');
    BlogMenu.$blogHeader.find('.burger-menu').removeClass('open');
  }


}
